// extracted by mini-css-extract-plugin
export default {"auto_list":"index_auto_list_ASZHQ"};